import React, { useState, useEffect } from "react";
import { useOutsideHoverClose } from "../../../../utils/useOutsideClose";
import { useProjectsList } from "../../../../contexts/ProjectsListContext";

interface FilterProps {
	className?: string;
}

const Filter = ({ className }: FilterProps) => {
	const {
		elementRef,
		isVisible: menuVisible,
		toggle,
	} = useOutsideHoverClose();

	const { filterData, activeFilter, filterProjects, selectFilter } =
		useProjectsList();

	useEffect(() => {
		filterProjects();
	}, [activeFilter]);

	return (
		<div className={`filter ${className}`} ref={elementRef}>
			<div className="menu-visible">
				<span className="menu-title">Filter:</span>

				<span className="menu-toggle hover" onClick={toggle}>
					{activeFilter.title}
				</span>
			</div>

			<div className={`menu ${menuVisible ? "visible" : "hidden"}`}>
				{filterData?.map((filter) => (
					<li key={filter.title} onClick={() => selectFilter(filter)}>
						{filter.title}
					</li>
				))}
			</div>
		</div>
	);
};

export default Filter;
